import { getTheme } from "@clipboard-health/ui-theme";
import { Stack, ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { ACCOUNTS_BASE_PATH } from "@src/appV2/redesign/Accounts/paths";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { PageContent } from "@src/appV2/redesign/WorkerShifts/components/PageContent";
import { useRef, useState } from "react";

import { UpdatePhoneSteps } from "../constants";
import { EnterPhoneStep } from "./components/EnterPhoneStep";
import { VerifyEmailStep } from "./components/VerifyEmailStep";
import { VerifyPhoneOtpStep } from "./components/VerifyPhoneOtpStep";

export function UpdatePhonePage() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentStep, setCurrentStep] = useState<UpdatePhoneSteps>(UpdatePhoneSteps.VERIFY_EMAIL);
  const [newPhone, setNewPhone] = useState<string>("");

  useLogEffect(APP_V2_USER_EVENTS.PROFILE_UPDATE_PHONE_INITIATED);

  const handleEmailVerified = () => {
    setCurrentStep(UpdatePhoneSteps.ENTER_PHONE);
  };

  const handlePhoneEntered = (phone: string) => {
    setNewPhone(phone);
    setCurrentStep(UpdatePhoneSteps.VERIFY_PHONE_OTP);
  };

  const handlePhoneUpdated = () => {
    logEvent(APP_V2_USER_EVENTS.PROFILE_UPDATE_PHONE_COMPLETED);
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <StickyScrollPageHeader
          title="Change Phone Number"
          scrollContainerRef={scrollRef}
          fallbackGoBackPath={ACCOUNTS_BASE_PATH}
          headerVariant="tertiary"
        />
        <PageContent ref={scrollRef}>
          <Stack
            sx={{
              maxWidth: "600px",
              marginX: "auto",
              width: "100%",
            }}
          >
            {currentStep === UpdatePhoneSteps.VERIFY_EMAIL && (
              <VerifyEmailStep onVerified={handleEmailVerified} />
            )}
            {currentStep === UpdatePhoneSteps.ENTER_PHONE && (
              <EnterPhoneStep onPhoneEntered={handlePhoneEntered} />
            )}
            {currentStep === UpdatePhoneSteps.VERIFY_PHONE_OTP && (
              <VerifyPhoneOtpStep phone={newPhone} onPhoneUpdated={handlePhoneUpdated} />
            )}
          </Stack>
        </PageContent>
      </PageWrapper>
    </ThemeProvider>
  );
}
